<div class="grid-container" fxLayout="column" fxLayoutAlign="center center">
	<div style="height: 300px; margin-top: 10%">
		<h1>Building dashboard...</h1>
	</div>
</div>
